import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import Paper from '../Paper/Paper';

type CardUIProps = {
  elevation?: number,
  variant?: 'elevation' | 'outlined',
  square?: boolean,
  children?: ReactNode,
} & HTMLAttributes<HTMLDivElement>;

// MUI Card is a Paper with `overflow: hidden` (same default elevation=1, radius).
// Reuse Paper so elevation/variant/shadow parity is shared. Call-site style still
// wins (Paper merges it last), so `overflow` is overridable.
const CardUI: FunctionComponent<CardUIProps> = ({ style, children, ...rest }) => (
  <Paper {...rest} style={{ overflow: 'hidden', ...style }}>
    {children}
  </Paper>
);

export default CardUI;
